import React, { useState } from "react";
import "../styles/FileUpload.css";
import { v4 as uuidv4 } from "uuid";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import CheckIcon from "@mui/icons-material/Check";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Snackbar, { SnackbarOrigin } from "@mui/joy/Snackbar";

export default function FileUpload({ onSkillsExtracted, generateRecommendations, data, jobs }) {
  const trendingSkills = [
    "React",
    "Node.js",
    "Docker",
    "AWS",
    "Python",
    "GraphQL",
  ];
  const [isLoading, setIsLoading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [error, setError] = useState(null);
  const parseSkillsFromText = (text) => {
    return trendingSkills.filter((skill) =>
      text.toLowerCase().includes(skill.toLowerCase())
    );
  };
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState("");

  const [snackBarOpen, setSnackbarOpen] = useState(false);

  const handleClose = (event) => {
    setSnackbarOpen(false);
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(".pdf")) {
      setError("Only PDF files are allowed.");
      setSnackbarOpen(true);
      return;
    }
    setFile(file);

    const fileName = `${Date.now()}-${uuidv4()}_${file.name}`;
    setFileName(fileName);

    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/generate-upload-url?filename=${fileName}`,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const uploadedFileData = await response.json();
      // Upload file to the signed URL
      const uploadResponse = await fetch(uploadedFileData.url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/pdf",
        },
        body: file,
      });
      if (!uploadResponse.ok) {
        throw new Error(`Upload failed! status: ${uploadResponse.status}`);
      }
      setIsUploaded(true);
      setSnackbarOpen(true);
      setError("");
    } catch (error) {
      console.error("Error during upload:", error);
      setError("Failed to upload file. Please try again.");
      setIsLoading(false);
      setIsUploaded(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleViewPdf = async (filename)=>{
    try{
      const data = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/view-pdf?filename=${filename}`,
        {
          method:'GET'
        }
      );

      const pdfUrl = await data.json();
      console.log(`Pdfurl ${pdfUrl.url}`)
      if (pdfUrl && pdfUrl.url) {
        window.open(pdfUrl.url, "_blank", "noopener,noreferrer");
      }
    }catch(err){

    }
  }

  // function getStatus() {
  //   return (
  //    <Box sx={{ width: 'inherit' }}>
  //       <LinearProgress />
  //     </Box>
  //   );
  // }

  async function generateRecommendation() {
    console.log("Generating recommendations for file:", fileName);
    generateRecommendations(fileName);
  }

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return isUploaded ? (
    <div className="uploaded-success-container">
      <div className="file-uploaded-name">
        <h2>{file.name}</h2>
        <Button
        variant="contained"
        className="view-pdf-button"
        onClick={
          ()=>{
            handleViewPdf(fileName);
          }
        }
        >
          View PDF
        </Button>
      </div>
      <div className="generate-recommendations">
        <Button
          variant="contained"
          className={
            (data && jobs.length == 0) ? "generate-button-disabled" : "generate-button"
          }
          disabled={data && jobs.length == 0}
          onClick={() => {
            generateRecommendation();
          }}
        >
          Generate Recommendations
        </Button>
      </div>
      <Snackbar
        className="upload-snackbar"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackBarOpen}
        onClose={handleClose}
        key={"bottomcenter"}
      >
        {isUploaded ? (
          <div className="upload-success">
            <CheckIcon color="success" />
            <span>File uploaded successfully!</span>
          </div>
        ) : error && error.length > 0 && !isUploaded ? (
          <div className="upload-error">
            <span>{error || "An error occurred during upload."}</span>
          </div>
        ) : (
          <div></div>
        )}
      </Snackbar>
    </div>
  ) : (
    <div className="upload-container">
      <Button
        component="label"
        role={undefined}
        variant="contained"
        tabIndex={-1}
        startIcon={
          isLoading ? (
            <CircularProgress size={24} color="success" />
          ) : (
            <CloudUploadIcon />
          )
        }
      >
        {!isLoading ? "Upload files" : "Uploading..."}
        <VisuallyHiddenInput
          type="file"
          onChange={(event) => handleFileUpload(event)}
          multiple
        />
      </Button>
    </div>
  );
}
